import "./NoResults.scss"

function NoResults() {
    return (
        <div className='no-results'>
            <h2>OOPS – NO RESULTS.</h2>
            <p>Don’t give up! Check the spelling, or try something less specific.</p>
        </div>
    )
}

export default NoResults
